import Dashboard from "../../../app/dashboard";
import Users from "../../../app/users";
import Statistics from "../../../app/statistics";
import Institutions from "../../../app/institutions";
import InstitutionForm from "../../../app/institutions/components/Form";
import AccountProfile from "../../../app/users/components/AccountProfile";
import Protocols from "../../../app/protocols";
import Settings from "../../../app/settings";
import Beacons from "../../../app/beacons";
import BeaconForm from "../../../app/beacons/components/Form";
import Incidents from "../../../app/incidents";
import IncidentForm from "../../../app/incidents/components/Form";
import ProtocolForm from "../../../app/protocols/components/Form";
import Groups from "../../../app/groups";
import GroupForm from "../../../app/groups/components/Form";

export const adminRoutes = [
  {
    category: "Dashboard",
    path: "/dashboard",
    icon: "ph-duotone ph-house-line",
    title: "navigation.dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    category: "Institutions",
    path: "/institutions",
    icon: "ph-duotone ph-buildings",
    title: "navigation.institutions",
    component: <Institutions />,
    showInSidebar: true,
  },
  {
    path: "/institutions/create",
    component: <InstitutionForm />,
  },
  {
    path: "/institutions/:institutionId",
    component: <InstitutionForm />,
  },
  {
    category: "Users",
    path: "/users",
    icon: "ph-duotone ph-users",
    title: "navigation.users",
    component: <Users />,
    showInSidebar: true,
  },
  {
    path: "/users/create",
    component: <AccountProfile />,
  },
  {
    path: "/users/:userId",
    component: <AccountProfile />,
  },
  {
    category: "Groups",
    path: "/groups",
    icon: "ph-duotone ph-users-three",
    title: "navigation.groups",
    component: <Groups />,
    showInSidebar: true,
  },
  {
    path: "/groups/create",
    component: <GroupForm />,
  },
  {
    path: "/groups/:groupId",
    component: <GroupForm />,
  },
  {
    category: "Beacons",
    path: "/beacons",
    icon: "ph-duotone ph-broadcast",
    title: "navigation.beacons",
    component: <Beacons />,
    showInSidebar: true,
  },
  {
    path: "/beacons/create",
    component: <BeaconForm />,
  },
  {
    path: "/beacons/:beaconId",
    component: <BeaconForm />,
  },
  {
    category: "Incidents",
    path: "/incidents",
    icon: "ph-duotone ph-warning",
    title: "navigation.incidents",
    component: <Incidents />,
    showInSidebar: true,
  },
  {
    path: "/incidents/create",
    component: <IncidentForm />,
  },
  {
    path: "/incidents/:incidentId",
    component: <IncidentForm />,
  },
  {
    category: "Protocols",
    path: "/protocols",
    icon: "ph-duotone ph-clipboard-text",
    title: "navigation.protocols",
    component: <Protocols />,
    showInSidebar: true,
  },
  {
    path: "/protocols/create",
    component: <ProtocolForm />,
  },
  {
    path: "/protocols/:protocolId",
    component: <ProtocolForm />,
  },
  {
    category: "Statistics",
    path: "/statistics",
    icon: "ph-duotone ph-chart-line-up",
    title: "navigation.statistics",
    component: <Statistics />,
    showInSidebar: true,
  },
  {
    category: "Settings",
    path: "/settings",
    icon: "ph-duotone ph-gear",
    title: "navigation.settings",
    component: <Settings />,
    showInSidebar: true,
  },
];
